"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.suffixIfSubject = exports.joinTruthyStrings = exports.wrap = exports.titleCase = exports.replace = exports.removeSpaces = exports.isString = exports.isEmpty = exports.capitalize = exports.camelCase = void 0;

var camelCase = function camelCase(sentence) {
  return sentence.split(' ').length > 1 ? sentence.split(' ').map(function (word, index) {
    return index === 0 ? word.toLowerCase() : word[0].toUpperCase() + word.substr(1).toLowerCase();
  }).join('') : sentence.toLowerCase();
};

exports.camelCase = camelCase;

var capitalize = function capitalize(input) {
  return input.charAt(0).toUpperCase() + input.slice(1);
};

exports.capitalize = capitalize;

var isEmpty = function isEmpty(input) {
  return input === '';
};

exports.isEmpty = isEmpty;

var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

exports.isString = isString;

var titleCase = function titleCase(title) {
  return title.split(' ').map(function (word) {
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }).join(' ');
};

exports.titleCase = titleCase;

var removeSpaces = function removeSpaces(str) {
  return str.replace(/\s/g, '');
};

exports.removeSpaces = removeSpaces;

var replace = function replace(what) {
  return function (with_) {
    return function (str) {
      return str.replace(what, with_);
    };
  };
};

exports.replace = replace;

var wrap = function wrap(left) {
  return function (right) {
    return function (content) {
      return left + content + right;
    };
  };
};

exports.wrap = wrap;

var joinTruthyStrings = function joinTruthyStrings(glue) {
  return function (strings) {
    return strings.filter(function (string) {
      return !!string;
    }).join(glue);
  };
};

exports.joinTruthyStrings = joinTruthyStrings;

var suffixIfSubject = function suffixIfSubject(subject, suffix) {
  if (subject) {
    return subject + suffix;
  }

  return undefined;
};

exports.suffixIfSubject = suffixIfSubject;
//# sourceMappingURL=index.js.map